export const toSentenceCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const loadScript = ({src, onLoad, async = true}) => {
  const script = document.createElement('script');
  script.src = src;
  script.async = async;
  script.onload = onLoad;
  document.body.appendChild(script);
};